import { useState, useEffect } from "react";

export default function useIsMobile(breakpoint = 768) {
  const get = () =>
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia(`(max-width:${breakpoint - 1}px)`).matches;

  const [isMobile, setIsMobile] = useState(get);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(`(max-width:${breakpoint - 1}px)`);
    const handler = (e) => setIsMobile(e.matches);
    // old + new browsers
    mql.addEventListener?.("change", handler) || mql.addListener(handler);
    return () =>
      mql.removeEventListener?.("change", handler) ||
      mql.removeListener(handler);
  }, [breakpoint]);

  return isMobile;
}
